
import {Component, Prop, Vue} from "vue-property-decorator";

export interface RaporSekme {
  kod: string;
  etiket: string;
  ikon: string;
  sayi?: number | null;
}

/**
 * Raporlar sayfasının sekme çubuğu. Vuetify'ın v-tabs/v-btn-toggle'ı yerine
 * düz buton kullanılıyor; çünkü tasarımdaki hap (pill) biçimi — 40px yükseklik,
 * seçilide vurgu tonlu zemin + vurgu kenarlık — ikisinin de varsayılanına
 * uymuyordu ve override etmek daha çok CSS demekti.
 *
 * Klavye: sekmeler arasında sol/sağ ok ile gezilir (WAI-ARIA tab pattern);
 * yalnız seçili sekme tab sırasında yer alır.
 */
@Component({})
export default class RaporSekmeler extends Vue {
  @Prop({required: true}) value!: string;
  @Prop({required: true}) sekmeler!: Array<RaporSekme>;

  sec(kod: string) {
    if (kod !== this.value) this.$emit("input", kod);
  }

  komsuyaGec(index: number, yon: number) {
    const hedef = (index + yon + this.sekmeler.length) % this.sekmeler.length;
    this.sec(this.sekmeler[hedef].kod);
    this.$nextTick(() => {
      const ref: any = (this.$refs["sekme" + hedef] as any);
      const el = Array.isArray(ref) ? ref[0] : ref;
      if (el && el.focus) el.focus();
    });
  }
}
